import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src3921127278/src/Conversational-bot/client/layouts/default.vue").then(m => m.default || m))
}